import { Col, Container, Row, Card, Badge, Image } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import brandData from '../../data/brandData.json';

const Testimonials = () => {
  const getImage = (imageName) => {
    return require(`../../assets/user_images/${imageName}`)
  }

  const renderStars = (rating) => {
    const stars = []
    const fullStars = Math.floor(rating)
    const hasHalfStar = rating % 1 !== 0

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={`full-${i}`} className="ri-star-fill"></i>)
    }
    if (hasHalfStar) {
      stars.push(<i key="half" className="ri-star-half-line"></i>)
    }
    return stars
  }

  return (
    <section className='section-lg overflow-hidden'>
      <Container>
        <Row>
          <Col xs={12} className='mb-5'>
            <motion.h6 className="underline-after position-relative text-center z-0"
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: 'linear', delay: 0.1 }}
            >
              <span className="position-relative z-1 bg-white text-primary px-3">Testimonials</span>
            </motion.h6>
            <motion.h1 className="d-block text-gradiant text-center fw-semibold"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: 'linear', delay: 0.1 }}
            >
              What founders say
            </motion.h1>
          </Col>
        </Row>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={24}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            768: {
              slidesPerView: 1,
            },
            992: {
              slidesPerView: 2,
            },
          }}
          className="testimonial-swiper"
        >
          {brandData.testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial.id}>
              <motion.div
                whileHover={{ y: -5, transition: { duration: 0.3 } }}
              >
                <Card className="h-100 border rounded-4 shadow-sm bg-white">
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <Image className="border border-2 border-primary-subtle"
                        src={getImage(testimonial.image)}
                        roundedCircle
                        alt={testimonial.name}
                        width={48}
                        height={48}
                      />
                      <div>
                        <strong className="d-block text-dark">{testimonial.name}</strong>
                        <small className="text-secondary">{testimonial.category}</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-1 mb-2 text-warning">
                      {renderStars(testimonial.stars)}
                      <small className="text-secondary ms-1">{testimonial.rating}</small>
                    </div>
                    <h6 className="mb-2 text-dark">{testimonial.title}</h6>
                    <p className="mb-0 fst-italic text-secondary border-start ps-3">
                      {testimonial.text}
                    </p>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div className="d-flex flex-wrap gap-2">
                        {testimonial.badges.map((badge, index) => (
                          <Badge key={index} bg={`${badge.variant}-subtle`} text={badge.variant} className="fw-normal">
                            {badge.text}
                          </Badge>
                        ))}
                      </div>
                      <small className="text-secondary">{testimonial.date}</small>
                    </div>
                  </Card.Body>
                </Card>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  )
}

export default Testimonials;
